module.exports = __webpack_public_path__ + "img/guide_07.6393b2ae.png";